import { render, staticRenderFns } from "./VolunteerVIPRecord.vue?vue&type=template&id=020009e4&"
import script from "./VolunteerVIPRecord.vue?vue&type=script&lang=js&"
export * from "./VolunteerVIPRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports